import React from 'react';

const ProcessIcon = ({ stroke }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 24.5C22.933 24.5 24.5 22.933 24.5 21C24.5 19.067 22.933 17.5 21 17.5C19.067 17.5 17.5 19.067 17.5 21C17.5 22.933 19.067 24.5 21 24.5Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 10.5C8.933 10.5 10.5 8.933 10.5 7C10.5 5.067 8.933 3.5 7 3.5C5.067 3.5 3.5 5.067 3.5 7C3.5 8.933 5.067 10.5 7 10.5Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 24.5V10.5C7 13.2848 8.10625 15.9555 10.0754 17.9246C12.0445 19.8938 14.7152 21 17.5 21"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ProcessIcon;
